import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { LineChart } from '@mui/x-charts/LineChart';
import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../../canalDist/canalDist.controll";
import { connect } from 'react-redux';
import { CardHeader } from '@mui/material';


function AreaGradient({ color, id }: { color: string; id: string }) {
  return (
    <defs>
      <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor={color} stopOpacity={0.5} />
        <stop offset="100%" stopColor={color} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
}



function ChartLineTotalCanal(props: CanalDistribuicaoViewProps) {
  const { getTotalFaturadoByPeriodo } = props.canalDistribuicaoActions;
  const { filtroMovCanal, chartLineSeries,chartLineDataAxis } = props.canalDistribuicaoState
  const theme = useTheme();
  
  React.useEffect(() => {
    getTotalFaturadoByPeriodo(filtroMovCanal)
  }, [])  

  const colorPalette = [
    theme.palette.primary.light,
    theme.palette.primary.main,
    theme.palette.primary.dark,
  ];

  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardHeader 
        title="Total faturado no período"
      />
      <CardContent>
        <LineChart
          colors={colorPalette}
          xAxis={[
            {
              scaleType: 'point',
              data:chartLineDataAxis,
              
            },
          ]}
          series={chartLineSeries}
          height={250}
          margin={{ left: 50, right: 20, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          sx={{
            '& .MuiAreaElement-series-organic': {
              fill: "url('#organic')",
            },
            '& .MuiAreaElement-series-referral': {
              fill: "url('#referral')",
            },
            '& .MuiAreaElement-series-direct': {
              fill: "url('#direct')",
            },
          }}
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
        >
          <AreaGradient color={theme.palette.primary.dark} id="organic" />
          <AreaGradient color={theme.palette.primary.main} id="referral" />
          <AreaGradient color={theme.palette.primary.light} id="direct" />
        </LineChart>
      </CardContent>
    </Card>
  );
}

export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(ChartLineTotalCanal);